import { getType } from 'typesafe-actions';

import { PANORAMA_STEP_MODES } from '../../constants/game';
import { setCurrentGame } from '../actions/game';
import { PanoramaStepMode, setPanoramaStepMode } from '../actions/settings';

export interface SettingsState {
    panoramaStepMode: PanoramaStepMode;
}

/**
 * Default při nové hře = STEP_1 (50 m fast jump). Jemnější krok = lepší kontrola
 * pro nového hráče.
 *
 * Pozn. k tradeoffu: větší kroky (STEP_2/STEP_3) šetří víc kreditů — Mapy.com účtují
 * per stažená dlaždice, takže méně načtených panoramat na ujetou vzdálenost = méně
 * dlaždic — ale jsou hrubší. Default je proto STEP_1 kvůli ovladatelnosti; hráč si
 * rychlost může kdykoliv přepnout přepínačem. Volba přežije refresh (redux-persist)
 * a resetuje se na tento default při nové hře.
 */
const DEFAULT_NEW_GAME_STEP_MODE = PANORAMA_STEP_MODES.STEP_1 as PanoramaStepMode;

const initialState: SettingsState = {
    panoramaStepMode: DEFAULT_NEW_GAME_STEP_MODE,
};

const settingsReducer = (state: SettingsState = initialState, action: any): SettingsState => {
    switch (action.type) {
        case getType(setPanoramaStepMode):
            return {
                ...state,
                panoramaStepMode: action.payload,
            };
        case getType(setCurrentGame):
            // Nová hra (round === 1) → reset módu na default. Reaguje na setCurrentGame
            // z game actions; je to cross-cutting reset, ale akce jsou globální.
            if (action.payload?.round === 1) {
                return {
                    ...state,
                    panoramaStepMode: DEFAULT_NEW_GAME_STEP_MODE,
                };
            }
            return state;
        default:
            return state;
    }
};

export default settingsReducer;
